"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
function printDebugValue(v) {
    return mobx_1.getDependencyTree(v);
}
exports.printDebugValue = printDebugValue;



//////////////////
// WEBPACK FOOTER
// ./~/mobx-react-lite/lib/printDebugValue.js
// module id = 1072
// module chunks = 0